import axios from 'axios';
import { call, put, takeEvery, takeLatest, select } from 'redux-saga/effects';
import constants from 'constants';
import actions from 'actions';
import { toast } from 'react-toastify';
import { push } from 'redux-router';
import validator from 'services/validator.js';
import validate from 'validate.js';
import _ from 'lodash';

const {
  addRequestError,
  addErrorsSaga,
  addValidateError,
  cleanErrors,
  addAdminSponsors,
  startRequest,
  endRequest,
  setTempSponsor
} = actions;

const {
  UPDATE_SPONSOR_SAGA,
  LOAD_ADMIN_SPONSORS_SAGA,
  ADMIN_DELETE_SPONSORS_SAGA,
  CREATE_SPONSOR_SAGA,
  API_ADMIN_SPONSORS,
  LOAD_SPONSOR_SAGA
} = constants;

const apiCreateSponsor = (sponsor) => (
  axios.post(API_ADMIN_SPONSORS, sponsor)
);

const apiUpdateSponsor = (id, sponsor) => (
  axios.put(`/api/v1/admin/sponsor/${id}`, sponsor)
);

const apiLoadAdminSponsors = (page, query) => (
  axios.get(API_ADMIN_SPONSORS, {
    params: {
      page,
      per_page: 5,
      ...query
    }
  })
);

const apiLoadSponsor = (id, params = {}) => (
  axios.get(`/api/v1/admin/sponsor/${id}`, {
    params: {
      ...params
    }
  })
);


const apiDeleteSponsors = (sponsor_ids) => {
  return axios.post('/api/v1/admin/sponsor/destroy', {
    sponsor_ids: sponsor_ids
  })
}

const formatRequestData = (sponsor) => {
  let data = new FormData();

  Object.keys(sponsor).forEach(field => {
    if (field === 'logo') return;
    data.append(`sponsor[${field}]`, sponsor[field]);
  });

  if (sponsor.logo instanceof File) {
    data.append('sponsor[logo]', sponsor.logo);
  }

  return data;
}


function* createSponsorSaga({ sponsor }) {
  try {
    if (yield select(store => store.requests.indexOf('sponsor_create') != -1))
      return;

    yield put(startRequest('sponsor_create'));

    const errors = validator.validate(sponsor, 'sponsor');
    if (errors) {
      yield put(addValidateError(CREATE_SPONSOR_SAGA, errors));
      yield put(endRequest('sponsor_create'));
      return;
    } else {
      yield put(cleanErrors(CREATE_SPONSOR_SAGA))
    }
    const sponsorRequestData = yield call(formatRequestData, sponsor);
    const response = yield call(apiCreateSponsor, sponsorRequestData);
    const createdSponsor = response.data.sponsor;
    toast.success('Sponsor successfully created!');
    yield put(push('/sponsors/'));
    yield put(endRequest('sponsor_create'));
  } catch (e) {
    yield put(endRequest('sponsor_create'));
    yield put(addErrorsSaga(CREATE_SPONSOR_SAGA, e.response))
  }
}

function* updateSponsorSaga({ sponsor }) {
  try {
    const errors = validator.validate(sponsor, 'sponsor');
    if (errors) {
      yield put(addValidateError(UPDATE_SPONSOR_SAGA, errors));
      return;
    } else {
      yield put(cleanErrors(UPDATE_SPONSOR_SAGA))
    }

    const sponsorRequestData = yield call(formatRequestData, sponsor);
    const response = yield call(apiUpdateSponsor, sponsor.id, sponsorRequestData);
    toast.success('Sponsor successfully updated!')
    yield put(push('/sponsors/'))
  } catch (e) {
    yield put(addErrorsSaga(UPDATE_SPONSOR_SAGA, e.response))
  }
}

function* deleteSponsors({ sponsor_ids }) {
  if (!sponsor_ids.length)
    return;
  const sponsorIds = sponsor_ids;
  try {
    yield call(apiDeleteSponsors, sponsorIds);
    toast.success('Sponsors successfully deleted!');
    const query = yield select(state => state.sponsors.admin.list.query) || {};
    const page = yield select(state => state.sponsors.admin.list.page) || 1;
    yield call(loadAdminSponsors, { page, query });
  } catch (e) {
    yield put(addErrorsSaga(ADMIN_DELETE_SPONSORS_SAGA, e.response))
  }
}

function* loadAdminSponsors({ page = 1, query = {} }) {
  try {
    const response = yield call(apiLoadAdminSponsors, page, query);
    const sponsors = response.data.sponsors;
    const count = response.data.count;
    const totalPages = response.data.total_pages;
    yield put(addAdminSponsors(sponsors, count, page, totalPages, query));

  } catch (e) {
    yield put(addRequestError(e.response))
  }
}


function* loadSponsorSaga({ id }) {
  try {
    const response = yield call(apiLoadSponsor, id);
    const sponsor = response.data.sponsor;
    yield put(setTempSponsor(sponsor))

  } catch (e) {
    yield put(addRequestError(e.response))
  }
}


function* __createSponsorSaga() {
  yield takeEvery(CREATE_SPONSOR_SAGA, createSponsorSaga);
}

function* __updateSponsorSaga() {
  yield takeEvery(UPDATE_SPONSOR_SAGA, updateSponsorSaga);
}

function* __deleteSponsorSaga() {
  yield takeEvery(ADMIN_DELETE_SPONSORS_SAGA, deleteSponsors);
}

function* __loadAdminSponsors() {
  yield takeEvery(LOAD_ADMIN_SPONSORS_SAGA, loadAdminSponsors)
}

function* __loadDashboardAdminSponsors() {
  yield takeEvery(LOAD_ADMIN_SPONSORS_SAGA, loadAdminSponsors)
}

function* __loadSponsorSaga() {
  yield takeEvery(LOAD_SPONSOR_SAGA, loadSponsorSaga);
}

export {
  __createSponsorSaga,
  __updateSponsorSaga,
  __deleteSponsorSaga,
  __loadAdminSponsors,
  __loadSponsorSaga
};



// WEBPACK FOOTER //
// ./src/sagas/admin/sponsors.js